<i18n
  src="@/locales/views/packing_house/process/exec_steps/show_process.yml"
  lang="yaml"
></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="this.routeName('list_processes')"
      :params="{
        packing_house_id: this.packing_house_id,
      }"
    ></go-back-link>

    <bread-crumbs
      :labels="[module_name, packing_house_process.name]"
    ></bread-crumbs>

    <div class="bg-white shadow overflow-hidden sm:rounded-md">
      <ul role="list" class="divide-y divide-gray-200">
        <li
          v-for="process_line_step in process_line_steps"
          :key="process_line_step.id"
        >
          <div
            :class="[
              'block ',
              process_line_step.access
                ? 'cursor-pointer hover:bg-gray-50'
                : 'cursor-not-allowed bg-gray-100',
            ]"
            @click.prevent="goToShowStep(process_line_step)"
          >
            <div class="px-4 py-4 sm:px-6">
              <div class="flex items-center justify-between">
                <p
                  :class="[
                    'text-sm font-medium truncate',
                    process_line_step.access
                      ? 'text-gray-900'
                      : 'text-gray-500',
                  ]"
                >
                  {{ process_line_step.name }}
                </p>
                <div
                  v-if="process_line_step.access"
                  class="ml-2 flex-shrink-0 flex"
                >
                  <a
                    class="link"
                    @click.prevent="goToShowStep(process_line_step)"
                  >
                    <i class="fa-solid fa-pen"></i>
                    <span class="space-icon"></span>
                    {{ $t("labels.manage_link") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/process/exec_steps/show_process.js";

export default {
  name: "PHProcessExecStepsShowProcess",
  data() {
    return {
      packing_house_process: {},
      process_line_steps: [],
    };
  },
  props: {
    packing_house_id: {
      required: true,
    },
    packing_house_process_id: {
      required: true,
    },
  },
  created() {
    this.checkIfAuthenticated().then(() => {
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.fetchPackingHouseProcess();
        this.fetchProcessLineSteps();
      });
    });
  },
  methods: {
    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },

    fetchProcessLineSteps: async function () {
      let response = await Requester.fetchProcessLineSteps(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.process_line_steps = response.data;
    },

    goToShowStep: function (process_line_step) {
      if (!process_line_step.access) {
        return;
      }
      this.$router.push({
        name: this.routeName("show_step"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          process_line_step_id: process_line_step.id,
        },
      });
    },
  },
};
</script>
